<div class="flex flex-col h-full">
  <div>
    <h1>Medarbejdere</h1>
  </div>
  <p-tabs
    [(value)]="medarbejdereService.activeTab"
    class="flex-1 border-1 overflow-hidden">
    <p-tablist>
      <p-tab value="list"><i class="pi pi-list"></i> Liste</p-tab>
      @if (
        medarbejdereService.selectedMedarbejder() ||
        medarbejdereService.mode() === 'create'
      ) {
        <p-tab value="detail"><i class="pi pi-file"></i> Detaljer</p-tab>
      }
      @if (medarbejdereService.activeTab() !== 'detail') {
        <div class="mt-2 ml-8">
          <p-button
            icon="pi pi-plus"
            outlined
            label="Opret medarbejdere"
            (click)="medarbejdereService.opretMedarbejder()"></p-button>
        </div>
      }
    </p-tablist>
    <p-tabpanels class="overflow-hidden">
      <p-tabpanel value="list">
        <app-letpensiondk-medarbejdere-list />
      </p-tabpanel>
      <p-tabpanel value="detail">
        <app-letpensiondk-medarbejdere-detail />
      </p-tabpanel>
    </p-tabpanels>
  </p-tabs>
</div>
